export default __webpack_public_path__ + "static/media/edit.e5c027b4.svg";